/**
 * @file paddlejs online
 * @author wanzhongyun
 */

import React, { useEffect } from 'react';
import { Button, Switch, Checkbox, Row, Col } from 'antd';
import classNames from 'classnames';

import PaddleExample from './../paddleExample/PaddleExample';
import PaddleJSBullets from './../paddleJSBullets/PaddleJSBullets';

import useJSOnlineHooks from './PaddleJSOnlineHooks';
import { IPaddleJsOnline } from './../../type';

import './style.less';


const PaddleJSOnline: React.FC<IPaddleJsOnline> = props => {
    
    const { title, desc, backgroundImageUrl, tipsWord, typeList } = props;

    const {
        onlineStatus,
        switchStatus,
        currentImage,
        modelStatus,
        checkboxValue,
        setOnlineStatus,
        setCurrentImage,
        setCheckboxValue,
        setModelStatus,
        switchOnchange,
        handleCheckboxChange,
        handlePhotoControlOpen,
        handlePhotoControlClose
    } = useJSOnlineHooks(typeList);

    useEffect(() => {
        setCurrentImage(typeList[0]?.imageUrl ?? '');
        setCheckboxValue([typeList[0]?.imageUrl]);
    }, [typeList, setCurrentImage, setCheckboxValue]);

    useEffect(() => {
        setOnlineStatus(onlineStatus);
    }, [onlineStatus, setOnlineStatus]);
    
    return (
        <div className='paddle-js-online-wrapper'>
            <div className='paddle-js-online-title'>{ title }</div>
            <div className='paddle-js-online-desc'>{ desc }</div>
            
            {
                !onlineStatus
                    ? <div className='paddle-js-online-exp-wrapper' style={{backgroundImage: `url(${backgroundImageUrl})`}}>
                        <div className='paddle-js-online-exp-control'>
                            {
                                tipsWord.split(';').map(item => <div className='paddle-js-online-exp-control-tips' key={item}>
                                    {item}
                                </div>)
                            }
                            <Button
                                className="paddle-js-online-exp-control-btn"
                                type="primary"
                                icon={<span className="control-btn-icon" />}
                                onClick={handlePhotoControlOpen}
                            >
                                开始体验
                            </Button>
                        </div>
                    </div>


                    : <div className='online-exp-type-wrapper'>
                        <div className='paddle-js-online-exp-wrapper online-exp' style={{backgroundImage: `url(${currentImage})`}}>
                            <div className='paddle-js-online-exp-control'>
                                {
                                    tipsWord.split(';').map(item => <div className='paddle-js-online-exp-control-tips' key={item}>
                                        {item}
                                    </div>)
                                }
                                <div className='paddle-js-online-barrage-penetration'>
                                    <span className='barrage-word'>弹幕穿透效果</span>
                                    <Switch className='barrage-switch' onChange={switchOnchange} disabled={modelStatus} />
                                </div>
                                {/* <video className='online-exp-video' ref={videoRef} width="640" height="480" autoPlay></video> */}
                                <Button
                                    className={classNames('paddle-js-online-exp-control-btn', {'control-disabled': modelStatus})}
                                    type="primary"
                                    icon={<span className='control-btn-icon' />}
                                    onClick={handlePhotoControlClose}
                                    disabled={modelStatus}
                                >
                                    关闭摄像头
                                </Button>
                            </div>
                            <PaddleExample image={currentImage} setModelStatus={setModelStatus} />
                            {
                                switchStatus && <PaddleJSBullets status={switchStatus} />
                            }
                        </div>

                        <div className='online-exp-type'>

                            <div className='online-exp-type-word'>
                                <span className='online-exp-type-word-title'>选择类型</span>
                                <span className='online-exp-type-word-icon' />
                            </div>

                            <Checkbox.Group value={checkboxValue} onChange={handleCheckboxChange}>
                                <Row>
                                    {
                                        typeList.map(item => <Col span={24}>
                                            <Checkbox value={item.imageUrl}>{ item.type }</Checkbox>
                                        </Col>)
                                    }
                                </Row>
                            </Checkbox.Group>
                        </div>

                    </div>
            }

        </div>
    );
};

export default PaddleJSOnline;